export default [
  // 合同模板导入弹窗
  {
    name: 'contract-template-import-popup',
    component: () => import(/* webpackChunkName: "contractTemplateImportPopup" */ './contract-template-import-popup.vue'),
  },
  // 合同模板预览弹窗
  {
    name: 'contract-template-preview-popup',
    component: () => import(/* webpackChunkName: "contractTemplatePreviewPopup" */ './contract-template-preview-popup.vue'),
  },
  // 合同详情弹窗
  {
    name: 'contract-detail-popup',
    component: () => import(/* webpackChunkName: "contractDetailPopup" */ './contract-detail-popup.vue'),
  },
];
